import { useDrag } from 'react-dnd'
import { useGame } from '../contexts/GameContext'
import type { Trash } from '../interfaces/GameScreen'
import { cn } from '../lib/utils'

export function TrashItem(item: Trash) {
	const { selectedTrash, handleTrashAnimationEnd, handleTrashSelect } = useGame()
	const [{ isDragging }, drag] = useDrag(() => ({
		type: 'trash',
		item: item,
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}))

	return (
		<div
			ref={drag}
			onClick={() => handleTrashSelect(item)}
			onAnimationEnd={() => handleTrashAnimationEnd(item)}
			className="animation-lixo fixed"
			style={{
				top: item.y,
				padding: '15px',
			}}
		>
			<img
				src={item.icon}
				alt={`Item ${item.id}`}
				className={cn('size-12 scale-100 drop-shadow-lg hover:scale-110', {
					'opacity-50': isDragging,
					'scale-125': selectedTrash?.id === item.id,
				})}
			/>
		</div>
	)
}

export default TrashItem
